import { ApiResetPasswordRequest, ResetPasswordRequest } from '../interfaces';

export function mapResetPasswordRequest(request: ResetPasswordRequest): ApiResetPasswordRequest {
  return {
    code: request.token,
    new_password: request.newPassword,
  };
}
